import React from 'react';
import PropTypes from 'prop-types';

import CourseHead from './CourseHead';
import MaterialTiles from '../Programs/Programs/ProgramsCard/MaterialTiles';
import { ArrowRight, CardIcon } from './icons';
import '../Programs/Programs/ProgramsCard/course-card.style.scss';

const hasMaterials = (course) => Boolean(
  course.presentation_link
  || course.google_pdf_url
  || course.youtube_link
  || course.vocabulary_link
  || course.vocabulary_token
  || course.video_url
  || course.is_show_homework
  || course.group_video_count > 0
);

const TrialFinanceCard = ({ course, onPay }) => (
  <article className={`fv2-card fv2-trial ${hasMaterials(course) ? '' : 'fv2-trial--plain'}`.trim()}>
    <CourseHead image={course.image} title={course.name} type={course.type}>
      <span className="v2-chip v2-chip--green fv2-trial__badge">Пробне</span>
    </CourseHead>

    {hasMaterials(course) && (
      <div className="fv2-trial__materials">
        <span className="fv2-trial__label">Матеріали пробного заняття</span>
        <MaterialTiles lesson={course} />
      </div>
    )}

    <div className="fv2-trial__actions">
      <p className="fv2-trial__text">Сподобалось? Оплатіть курс, щоб продовжити навчання з викладачем.</p>
      <button type="button" className="v2-btn v2-btn--green fv2-trial__pay" onClick={onPay}>
        <CardIcon />
        Оплатити курс
        <ArrowRight />
      </button>
    </div>
  </article>
);

TrialFinanceCard.propTypes = {
  course: PropTypes.object.isRequired,
  onPay: PropTypes.func.isRequired,
};

export default TrialFinanceCard;
